import { Injectable } from '@angular/core';
import { environment } from '@enviroment/environment';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root',
})

export class EncryptionService {

    environment = environment;
    private ENCRYPTION_PREFIX = 'em-';

    constructor() {
    }

    // Encriptar datos generales (para otros usos, por ejemplo Gepetto, no solo cookies)
    encrypt(data: any): string {
        if (data === null || data === undefined) {
            return '';
        }
        const stringifiedData = JSON.stringify(data);
        const encryptedData = CryptoJS.AES.encrypt(stringifiedData, this.environment?.KEY_ENCRIPTION).toString();
        return this.ENCRYPTION_PREFIX + encryptedData;
    }

    // Desencriptar datos generales
    decrypt(encryptedData: string): any {
        if (!encryptedData) {
            return null;
        }

        // 1. Intenta desencriptar con la nueva versión (con prefijo)
        if (encryptedData.startsWith(this.ENCRYPTION_PREFIX)) {
            const actualEncryptedData = encryptedData.substring(this.ENCRYPTION_PREFIX.length);
            try {
                const bytes = CryptoJS.AES.decrypt(actualEncryptedData, this.environment?.KEY_ENCRIPTION);
                // Intentar convertir a UTF8. Si falla, el dato no es válido.
                const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
                return JSON.parse(decryptedData);
            } catch (e) {
                console.error(e);
            }
        }

        // 2. Si no tiene el prefijo o la desencriptación de la nueva versión falló,
        // intenta desencriptar con la versión antigua (sin prefijo).
        try {
            const bytes = CryptoJS.AES.decrypt(encryptedData, this.environment?.KEY_ENCRIPTION);
            // Validar si los bytes resultantes son una cadena UTF8 válida.
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            // Intenta parsear como JSON, si falla, puede que no fuera un JSON stringificado
            // (caso si encrypt no usaba JSON.stringify).
            return JSON.parse(decryptedData);
        } catch (e) {
            console.error(e);
            return null;
        }
    }

    // Encriptar valores de cookie específicos
    encryptCookie(value: string): string {
        if (!value) {
            return '';
        }

        // Sanear el valor antes de encriptar
        const sanitizedValue = encodeURIComponent(value);
        const encryptedData = CryptoJS.AES.encrypt(sanitizedValue, this.environment?.KEY_ENCRIPTION).toString();
        return this.ENCRYPTION_PREFIX + encryptedData;
    }

    // Desencriptar valores de cookie específicos
    decryptCookie(value: string): string | null {
        if (!value || !value.startsWith(this.ENCRYPTION_PREFIX)) {
            return null;
        }
        const actualEncryptedData = value.substring(this.ENCRYPTION_PREFIX.length);
        try {
            const bytes = CryptoJS.AES.decrypt(actualEncryptedData, this.environment?.KEY_ENCRIPTION);
            const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
            return decodeURIComponent(decryptedData);
        } catch (e) {
            console.error('Error al desencriptar cookie:', e);
            return null;
        }
    }

    isEncrypted(value: string): boolean {
        return value.startsWith(this.ENCRYPTION_PREFIX);
    }

}
